import React, { useEffect } from "react";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { useHistory } from "react-router";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { useGlobalStore } from "@/store/hooks";
import ShopType from "@/enum/ShopType";

const useResetTab = (currentTab: OrderTab, shopId: number) => {
    const orderManagementStore = useOrderManagementStore();
    const globalStore = useGlobalStore();
    const { hasAbnormalOrders, totalLogisticsWarningOrders } = orderManagementStore?.orderListCount || {};

    const history = useHistory();

    useEffect(() => {
        // 删除所有的异常后 如果没有异常订单 则回到待发货
        if (currentTab === OrderTab.ABNORMAL && hasAbnormalOrders === false) {
            history.push(`/order/list?shopId=${shopId}&tab=${OrderTab.PENDING_SHIPMENT}`);

            return;
        }

        const shop = globalStore.shopMapping.get(shopId);

        /** 由于PDD在物流预警下有两个子Tab，所以无预警订单后不跳转回待发货中 */
        if (
            currentTab === OrderTab.LOGISTICS_WARNING &&
            totalLogisticsWarningOrders === 0 &&
            ![ShopType.PINDUODUO, ShopType.PDD_FDS].includes(shop?.type)
        ) {
            history.push(`/order/list?shopId=${shopId}&tab=${OrderTab.PENDING_SHIPMENT}`);

            return;
        }
    }, [hasAbnormalOrders, totalLogisticsWarningOrders, currentTab]);
};

export default useResetTab;
